import React, { useContext, useMemo } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import PropTypes from 'prop-types';
import { Text } from '@bingads-webui-react/fabric-control';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';

export const AudienceSignal = ({ data }) => {
  const i18n = useContext(I18nContext);
  // get audience signal name
  const audienceSignalName = useMemo(() => data && data.Name, [data]);

  return (
    <PropertyRow propertyLabel={{ label: _TL_('Audience signal') }}>
      <Text>{audienceSignalName || i18n.getString(_TL_('No audience signal'))}</Text>
    </PropertyRow>
  );
};

AudienceSignal.propTypes = {
  data: PropTypes.arrayOf(PropTypes.string),
};

AudienceSignal.defaultProps = {
  data: [],
};
